import { createContext } from 'react'

/**
 * Provides the current page ID for linking group state scoping.
 * Each DashboardLayout wraps its widgets with this context so that
 * linking state (colors, group state, unlinked card state) is isolated per page.
 *
 * Defaults to 'default' so components rendered outside a DashboardLayout
 * (e.g. onboarding chat) still work without errors.
 */
export const LinkingPageContext = createContext<string>('default')
